/**
* @author lmcarrillo <lmcarrillo@sergas.net>
* @copyright Boqueixon 2023
* @version 20.60.60
* @license licenses.txt
*
* @date 2023-03-19 12:47:50
**/

import { Component , OnInit } from "@angular/core";
import { Router, Event, NavigationStart, NavigationEnd, NavigationError } from "@angular/router";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { environment } from "./../../../../src/environments/environment";
import { TranslateService } from "@ngx-translate/core";
import { Storage } from "@ionic/storage";
import { Globals } from "../../class/globals/globals";
import { TranslateConfiguration } from "../../class/translate-configuration/translate-configuration";
import { Validators } from "@angular/forms";
import { FormBuilder } from "@angular/forms";
import { FormGroup } from "@angular/forms";
import { FormControl } from "@angular/forms";
import { InAppBrowser } from "@ionic-native/in-app-browser/ngx";
import { InAppBrowserOptions } from "@ionic-native/in-app-browser/ngx";
import { Platform } from "@ionic/angular";
import { AlertController } from "@ionic/angular";
import { PopoverController } from "@ionic/angular";
import { PopoverComponent } from "../../components/popover/popover.component";



@Component({
	selector: "app-contacta",
	templateUrl: "contacta.page.html",
	styleUrls: ["contacta.page.scss"],
})

export class ContactaPage {
	
	pageName:string = `contacta` ;
	
	/**
	* ContactaPage:constructor()
	**/
	constructor(
		private router: Router,
		public statusBar: StatusBar,
		public translateService: TranslateService,
		public formBuilder: FormBuilder,
		public inAppBrowser: InAppBrowser,
		public platform: Platform,
		public alertController: AlertController,
		public popoverController: PopoverController,
		private storage: Storage,
		private globals: Globals,
		private translateConfiguration: TranslateConfiguration
	){
	
		// statusbar
		this.statusBar.styleBlackOpaque();
		this.statusBar.overlaysWebView(false);
		this.statusBar.backgroundColorByHexString("#0955b3");
	
		// translate
		this.translateConfiguration.setDefaultLanguage();

	
	

		console.log(`ContactaPage`,`pageName`,this.pageName);
	}
	
	/**
	* ContactaPage:showPopover()
	**/
	async showPopover(ev: any) {
		const popover = await this.popoverController.create({
			component: PopoverComponent,
			event: ev,
			translucent: true
		});
		return await popover.present();
	}
	
	


		
	
	smsRecipient: string = "630182281";
	whatsappRecipient: string = "630182281";
	emailRecipient: string = "info@lmco.es";
	emailSubject: string = "Boqueixon App";
	emptyMessage: string = "Tu mensaje no puede estar vacío";
	
	
	
	formContacta: FormGroup;
	
	/**
	* ContactaPage.resetFieldValues()
	**/
	public resetFieldValues(){
		this.formContacta = this.formBuilder.group({
			via : ["via-email", Validators.required],
			content : ["", Validators.required]
		});
	}
	
	
	/**
	* ContactaPage.runWhatsapp()
	**/
	private runWhatsapp(phone_number: string, message: string){
		let myMessage = message || "Hi";
		let phoneNumber = phone_number || "08123456789";
		if(myMessage == ""){
			myMessage = "Hi";
		}
		let urlSchema = "https://api.whatsapp.com/send?phone=" + encodeURIComponent(phoneNumber) + "&text=" + encodeURIComponent(myMessage) ;
		this.inAppBrowser.create(urlSchema,"_system");
	}
	
	
	/**
	* ContactaPage.runSmsApp()
	**/
	private runSmsApp(phone_number: string, message : string){
		let phoneNumber = phone_number || "08123456789";
		let textMessage = encodeURI(message) || "";
		let urlSchema;
		if (this.platform.is("ios")){
			urlSchema = "sms:" + phoneNumber + ";?&body=" + textMessage;
		}else{
			urlSchema = "sms:" + phoneNumber + "?body=" + textMessage;
		}
		this.inAppBrowser.create(urlSchema,"_system");
	}
	
	
	/**
	* ContactaPage.runMailApp()
	**/
	private runMailApp(email: string, subject : string, message : string){
		let emailAddr = email || "info@ihsana.com";
		let textSubject = subject || "email subject";
		let textMessage = encodeURI(message) || "write your message";
		if(textSubject == ""){
			textSubject = "email subject";
		}
		if(textMessage == ""){
			textMessage = "your message";
		}
		let urlSchema = "mailto:" + emailAddr + "?subject=" + textSubject + "&body=" + textMessage;
		this.inAppBrowser.create(urlSchema,"_system");
	}
	
	
	/**
	* ContactaPage.onSubmit()
	**/
	public onSubmit(){
		let data:any = this.formContacta.value; 
		if(data.content !== "" ){ 
			switch(data.via){ 
				case "via-sms":{
					this.runSmsApp(this.smsRecipient, data.content);
					break;
				}
				case "via-whatsapp":{
					this.runWhatsapp(this.whatsappRecipient,data.content);
					break;
				}
				case "via-email":{
					this.runMailApp(this.emailRecipient,this.emailSubject,data.content);
					break;
				}
			}
			this.resetFieldValues();
		}else{
			this.showAlert(null,this.emptyMessage,null);
		}
	}
	
	
	/**
	* ContactaPage.showAlert()
	**/
	async showAlert(header:string, subheader: string, message: string){
		const alert = await this.alertController.create({
			header: header,
			subHeader: subheader,
			//message: message,
			buttons: ["OK"]
		});
		await alert.present();
	}
	
	
	/**
	* ContactaPage.ngOnInit()
	**/
	ngOnInit(){
		this.resetFieldValues();
	}




}
